import {Box, Button, Grid} from "@mui/material";
import CustomAudioPlayer from "./CustomAudioPlayer";

interface AudioProps {
    getAudio: () => any,
    audioBlobPart: BlobPart
}

export default function Audio(props: AudioProps) {

    return (
        <Grid container alignItems={"center"} flexDirection={"column"}>
            <Box margin={2}>
                <Button variant={"contained"} onClick={props.getAudio}>get audio file</Button>
            </Box>
            <Grid margin={2}>
                {props.audioBlobPart &&
                    <CustomAudioPlayer audiofile={window.URL.createObjectURL(new Blob([props.audioBlobPart!]))} slider={true} download={true} autoPlay={true}/>
                }
            </Grid>
        </Grid>
    )
}